import { styled } from "@mui/material/styles"

export const Container = styled("div")({
    display: "flex",
    flexDirection: "column",
})